import PropTypes from "prop-types";
import { Ok } from "react-ikonate";
import styles from "./CircleCheckbox.module.css";

/**
 * Interactive component. A button that allows the user to reset their vote on a decision item.
 */
export function CircleCheckbox({ checked, name, onChange }) {
  return (
    <>
      <div className={styles.container}>
        {/* <div className={styles.icon}> */}
        <div className={styles.iconDiv}>
          <input
            type="checkbox"
            className={styles.checkbox}
            checked={checked}
            onChange={onChange}
            name={name}
          />

          <Ok className={styles.icon} />
        </div>

        {/* </div> */}
        <label htmlFor={name}>{name}</label>
      </div>
    </>
  );
}

CircleCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string,
};
